import { fetch } from '@atlassian/eoc-fetch';
export const getTeam = teamId => fetch(`/v1/alerts/responders/names`, {
  method: 'POST',
  body: {
    responders: [{
      id: teamId,
      type: 'team'
    }]
  }
});